/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateSalesOrderPaymentDto } from '../models/CreateSalesOrderPaymentDto';
import type { PaymentSummaryDto } from '../models/PaymentSummaryDto';
import type { SalesOrderPayment } from '../models/SalesOrderPayment';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class SalesOrderPaymentsService {
    /**
     * Process a payment for a sales order
     * @param requestBody
     * @returns SalesOrderPayment Payment processed successfully
     * @throws ApiError
     */
    public static salesOrderPaymentsControllerProcessPayment(
        requestBody: CreateSalesOrderPaymentDto,
    ): CancelablePromise<SalesOrderPayment> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/sales-order-payments',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid payment data`,
            },
        });
    }
    /**
     * Get all payments for a sales order
     * @param orderId
     * @returns SalesOrderPayment Payments retrieved successfully
     * @throws ApiError
     */
    public static salesOrderPaymentsControllerGetPaymentsByOrder(
        orderId: number,
    ): CancelablePromise<Array<SalesOrderPayment>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/sales-order-payments/by-order/{orderId}',
            path: {
                'orderId': orderId,
            },
        });
    }
    /**
     * Get payment summary for a sales order
     * @param orderId
     * @returns PaymentSummaryDto Payment summary retrieved successfully
     * @throws ApiError
     */
    public static salesOrderPaymentsControllerGetPaymentSummary(
        orderId: number,
    ): CancelablePromise<PaymentSummaryDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/sales-order-payments/summary/{orderId}',
            path: {
                'orderId': orderId,
            },
        });
    }
    /**
     * Get pending installment payments
     * @returns SalesOrderPayment Pending installments retrieved successfully
     * @throws ApiError
     */
    public static salesOrderPaymentsControllerGetPendingInstallments(): CancelablePromise<Array<SalesOrderPayment>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/sales-order-payments/pending-installments',
        });
    }
    /**
     * Get overdue payments
     * @returns SalesOrderPayment Overdue payments retrieved successfully
     * @throws ApiError
     */
    public static salesOrderPaymentsControllerGetOverduePayments(): CancelablePromise<Array<SalesOrderPayment>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/sales-order-payments/overdue',
        });
    }
    /**
     * Get payment statistics
     * @param startDate Start date for statistics (YYYY-MM-DD)
     * @param endDate End date for statistics (YYYY-MM-DD)
     * @returns any
     * @throws ApiError
     */
    public static salesOrderPaymentsControllerGetPaymentStatistics(
        startDate?: string,
        endDate?: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/sales-order-payments/statistics',
            query: {
                'startDate': startDate,
                'endDate': endDate,
            },
        });
    }
    /**
     * Get all payments with optional filters
     * @param status Filter by payment status
     * @param orderId Filter by sales order ID
     * @param startDate Start date for date range filter (YYYY-MM-DD)
     * @param endDate End date for date range filter (YYYY-MM-DD)
     * @returns SalesOrderPayment Payments retrieved successfully
     * @throws ApiError
     */
    public static salesOrderPaymentsControllerFindAll(
        status?: 'COMPLETED' | 'PENDING' | 'SCHEDULED' | 'FAILED' | 'CANCELLED' | 'REFUNDED',
        orderId?: number,
        startDate?: string,
        endDate?: string,
    ): CancelablePromise<Array<SalesOrderPayment>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/sales-order-payments/all',
            query: {
                'status': status,
                'orderId': orderId,
                'startDate': startDate,
                'endDate': endDate,
            },
        });
    }
    /**
     * Update payment status
     * @param id
     * @returns SalesOrderPayment Payment status updated successfully
     * @throws ApiError
     */
    public static salesOrderPaymentsControllerUpdatePaymentStatus(
        id: number,
    ): CancelablePromise<SalesOrderPayment> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/sales-order-payments/{id}/status',
            path: {
                'id': id,
            },
            errors: {
                404: `Payment not found`,
            },
        });
    }
    /**
     * Cancel/reverse a payment
     * @param id
     * @returns void
     * @throws ApiError
     */
    public static salesOrderPaymentsControllerCancelPayment(
        id: number,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/sales-order-payments/{id}',
            path: {
                'id': id,
            },
            errors: {
                404: `Payment not found`,
            },
        });
    }
}
